// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgColor from "../../../components/svg-color";
const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  user: icon("customer"),
  accounts: icon("ledger"),
  lock: icon("settings"),
  staff: icon("staff"),
  Inventory: icon("inventory"),
  analytics: icon("report"),
  dashboard: icon("dashboard"),
};

const navConfig = [
  // GENERAL
  {
    subheader: "Welcome Back!",
    items: [
      {
        title: "dashboard",
        path: PATH_DASHBOARD.general.app,
        pathList: [PATH_DASHBOARD.general.app],
        icon: ICONS.dashboard,
      },

      // HRM
      {
        title: 'HRM',
        path: PATH_DASHBOARD.hrm.root,
        matchPathList: true,
        pathList: [
          PATH_DASHBOARD.hrm.root,
          PATH_DASHBOARD.user.new,
          PATH_DASHBOARD.user.list,
          PATH_DASHBOARD.user.profile,
          PATH_DASHBOARD.user.edit,
          PATH_DASHBOARD.user.replicate,
        ],
        icon: ICONS.staff,
        children: [
          {
            title: 'Users',
            path: PATH_DASHBOARD.hrm.staff,
            matchPathList: true,
            pathList: [
              PATH_DASHBOARD.hrm.staff,
              PATH_DASHBOARD.user.new,
              PATH_DASHBOARD.user.list,
              PATH_DASHBOARD.user.profile,
              PATH_DASHBOARD.user.edit,
              PATH_DASHBOARD.user.replicate,
            ],
          },
        ],
      },

      // Stock
      // {
      //   title: "stock",
      //   path: PATH_DASHBOARD.stock.display,
      //   pathList: [
      //     PATH_DASHBOARD.stock.display,
      //     PATH_DASHBOARD.stock.new,
      //     PATH_DASHBOARD.stock.edit,
      //     // PATH_DASHBOARD.inventory.adjustment,
      //     // PATH_DASHBOARD.inventory.adjustmentEdit,

      //     // PATH_DASHBOARD.inventory.replicate,
      //   ],
      //   icon: ICONS.Inventory,
      // },

      {
        title: "Inventory",
        path: PATH_DASHBOARD.inventory.list,
        pathList: [
          PATH_DASHBOARD.inventory.list,
        ],
        icon: ICONS.Inventory,
      },

      {
        title: "Stores",
        path: PATH_DASHBOARD.stores.list,
        pathList: [
          PATH_DASHBOARD.stores.list,
          PATH_DASHBOARD.stores.new,
          PATH_DASHBOARD.stores.edit,
        ],
        icon: ICONS.Inventory,
      },

      {
        title: "Stores Item",
        path: PATH_DASHBOARD.storeItems.list,
        pathList: [PATH_DASHBOARD.storeItems.list],
        icon: ICONS.Inventory,
      },

      // Live Stock
      // {
      //   title: "Live stock",
      //   path: PATH_DASHBOARD.stock.live,
      //   pathList: [PATH_DASHBOARD.stock.live],
      //   icon: ICONS.Inventory,
      // },
      // Live Stock
      // {
      //   title: "Adjustment",
      //   path: PATH_DASHBOARD.stock.adjustment,
      //   pathList: [
      //     PATH_DASHBOARD.stock.adjustment,
      //     PATH_DASHBOARD.stock.addAdjustment,
      //     PATH_DASHBOARD.stock.adjustmentEdit,
      //   ],
      //   icon: ICONS.Inventory,
      // },

      // Ingredient
      // {
      //   title: "Item",
      //   path: PATH_DASHBOARD.item.list,
      //   pathList: [
      //     PATH_DASHBOARD.item.list,
      //     PATH_DASHBOARD.item.new,
      //     PATH_DASHBOARD.item.edit
      //   ],
      //   icon: ICONS.Inventory,
      // },

      // Purchase Order
      // {
      //   title: "Purchase Order",
      //   path: PATH_DASHBOARD.stock.purchaseOrders,
      //   pathList: [
      //     PATH_DASHBOARD.stock.purchaseOrders,
      //     PATH_DASHBOARD.stock.addPurchaseOrders,
      //     PATH_DASHBOARD.stock.purchaseOrderEdit,
      //   ],
      //   icon: ICONS.Inventory,
      // },

      {
        title: "Stocks",
        path: PATH_DASHBOARD.stocks.requests,
        pathList: [
          PATH_DASHBOARD.stocks.requests,
          PATH_DASHBOARD.stocks.requestDetail,
          PATH_DASHBOARD.stocks.transfers,
          PATH_DASHBOARD.stocks.transferNew,
          PATH_DASHBOARD.stocks.transferDetail,
          PATH_DASHBOARD.stocks.returns,
          PATH_DASHBOARD.stocks.returnDetail,
        ],
        icon: ICONS.Inventory,
        children: [
          {
            title: "Stock Requests",
            path: PATH_DASHBOARD.stocks.requests,
            pathList: [
              PATH_DASHBOARD.stocks.requests,
              PATH_DASHBOARD.stocks.requestDetail,
            ],
          },
          {
            title: "Stock Transfer",
            path: PATH_DASHBOARD.stocks.transfers,
            pathList: [
              PATH_DASHBOARD.stocks.transfers,
              PATH_DASHBOARD.stocks.transferNew,
              PATH_DASHBOARD.stocks.transferDetail,
            ],
          },
          {
            title: "Stock Return",
            path: PATH_DASHBOARD.stocks.returns,
            pathList: [
              PATH_DASHBOARD.stocks.returns,
              PATH_DASHBOARD.stocks.returnDetail,
            ],
          },
        ],
      },

      // Suppliers
      {
        title: 'suppliers',
        path: PATH_DASHBOARD.supplier.list,
        pathList: [
          PATH_DASHBOARD.supplier.new,
          PATH_DASHBOARD.supplier.list,
          PATH_DASHBOARD.supplier.edit,
          PATH_DASHBOARD.supplier.replicate,
        ],
        icon: ICONS.user,
      },

      // Catalog
      {
        title: 'catalog',
        path: PATH_DASHBOARD.catalog.categories.list,
        pathList: [
          PATH_DASHBOARD.catalog.categories.list,
          PATH_DASHBOARD.catalog.categories.edit,
          PATH_DASHBOARD.catalog.products.list,
          PATH_DASHBOARD.catalog.products.edit,
        ],
        icon: ICONS.Inventory,
        children: [
          {
            title: 'Categories',
            path: PATH_DASHBOARD.catalog.categories.list,
            pathList: [
              PATH_DASHBOARD.catalog.categories.list,
              PATH_DASHBOARD.catalog.categories.edit,
            ],
          },
          {
            title: 'Products',
            path: PATH_DASHBOARD.catalog.products.list,
            pathList: [
              PATH_DASHBOARD.catalog.products.list,
              PATH_DASHBOARD.catalog.products.edit,
            ],
          },
        ],
      },

      {
        title: "Accounts",
        path: PATH_DASHBOARD.accounts.purchasedOrder,
        pathList: [
          PATH_DASHBOARD.accounts.purchasedOrder,
          PATH_DASHBOARD.accounts.purchasedOrderNew,
          PATH_DASHBOARD.accounts.purchasedOrderDetail,
          PATH_DASHBOARD.accounts.purchasedOrderEdit,
          PATH_DASHBOARD.accounts.goodReceiptNote,
          PATH_DASHBOARD.accounts.goodReceiptNoteNew,
          PATH_DASHBOARD.accounts.goodReceiptNoteDetail,
          PATH_DASHBOARD.accounts.goodReceiptNoteEdit,
          PATH_DASHBOARD.accounts.apInvoice,
          PATH_DASHBOARD.accounts.apInvoiceNew,
          PATH_DASHBOARD.accounts.apInvoiceDetail,
          PATH_DASHBOARD.accounts.apInvoiceEdit,
          PATH_DASHBOARD.accounts.advancePayment,
          PATH_DASHBOARD.accounts.advancePaymentNew,
          PATH_DASHBOARD.accounts.advancePaymentDetail,
          PATH_DASHBOARD.accounts.advancePaymentEdit,
          PATH_DASHBOARD.accounts.banking,
          PATH_DASHBOARD.accounts.bankingNew,
          PATH_DASHBOARD.accounts.bankingDetail,
          PATH_DASHBOARD.accounts.bankingEdit,
          PATH_DASHBOARD.accounts.purchaseOrderReturn,
          PATH_DASHBOARD.accounts.purchaseOrderReturnNew,
          PATH_DASHBOARD.accounts.purchaseOrderReturnDetail,
          PATH_DASHBOARD.accounts.purchaseOrderReturnEdit,
          PATH_DASHBOARD.accounts.goodReceiptNoteReturn,
          PATH_DASHBOARD.accounts.goodReceiptNoteReturnNew,
          PATH_DASHBOARD.accounts.goodReceiptNoteReturnDetail,
          PATH_DASHBOARD.accounts.goodReceiptNoteReturnEdit,
          PATH_DASHBOARD.accounts.apInvoiceReturn,
          PATH_DASHBOARD.accounts.apInvoiceReturnNew,
          PATH_DASHBOARD.accounts.apInvoiceReturnDetail,
          PATH_DASHBOARD.accounts.apInvoiceReturnEdit,
          PATH_DASHBOARD.accounts.advancePaymentReturn,
          PATH_DASHBOARD.accounts.advancePaymentReturnNew,
          PATH_DASHBOARD.accounts.advancePaymentReturnDetail,
          PATH_DASHBOARD.accounts.advancePaymentReturnEdit,
          PATH_DASHBOARD.accounts.bankingReturn,
          PATH_DASHBOARD.accounts.bankingReturnNew,
          PATH_DASHBOARD.accounts.bankingReturnDetail,
          PATH_DASHBOARD.accounts.bankingReturnEdit,
        ],
        icon: ICONS.accounts,
        children: [
          {
            title: "Purchased Order",
            path: PATH_DASHBOARD.accounts.purchasedOrder,
            pathList: [
              PATH_DASHBOARD.accounts.purchasedOrder,
              PATH_DASHBOARD.accounts.purchasedOrderNew,
              PATH_DASHBOARD.accounts.purchasedOrderDetail,
              PATH_DASHBOARD.accounts.purchasedOrderEdit,
            ],
          },
          {
            title: "Good Receipt Note",
            path: PATH_DASHBOARD.accounts.goodReceiptNote,
            pathList: [
              PATH_DASHBOARD.accounts.goodReceiptNote,
              PATH_DASHBOARD.accounts.goodReceiptNoteNew,
              PATH_DASHBOARD.accounts.goodReceiptNoteDetail,
              PATH_DASHBOARD.accounts.goodReceiptNoteEdit,
            ],
          },
          {
            title: "AP Invoices",
            path: PATH_DASHBOARD.accounts.apInvoice,
            pathList: [
              PATH_DASHBOARD.accounts.apInvoice,
              PATH_DASHBOARD.accounts.apInvoiceNew,
              PATH_DASHBOARD.accounts.apInvoiceDetail,
              PATH_DASHBOARD.accounts.apInvoiceEdit,
            ],
          },
          {
            title: "Advance Payments",
            path: PATH_DASHBOARD.accounts.advancePayment,
            pathList: [
              PATH_DASHBOARD.accounts.advancePayment,
              PATH_DASHBOARD.accounts.advancePaymentNew,
              PATH_DASHBOARD.accounts.advancePaymentDetail,
              PATH_DASHBOARD.accounts.advancePaymentEdit,
            ],
          },
          {
            title: "Banking",
            path: PATH_DASHBOARD.accounts.banking,
            pathList: [
              PATH_DASHBOARD.accounts.banking,
              PATH_DASHBOARD.accounts.bankingNew,
              PATH_DASHBOARD.accounts.bankingDetail,
              PATH_DASHBOARD.accounts.bankingEdit,
            ],
          },
          {
            title: "PO Returns",
            path: PATH_DASHBOARD.accounts.purchaseOrderReturn,
            pathList: [
              PATH_DASHBOARD.accounts.purchaseOrderReturn,
              PATH_DASHBOARD.accounts.purchaseOrderReturnNew,
              PATH_DASHBOARD.accounts.purchaseOrderReturnDetail,
              PATH_DASHBOARD.accounts.purchaseOrderReturnEdit,
            ],
          },
          {
            title: "GRN Returns",
            path: PATH_DASHBOARD.accounts.goodReceiptNoteReturn,
            pathList: [
              PATH_DASHBOARD.accounts.goodReceiptNoteReturn,
              PATH_DASHBOARD.accounts.goodReceiptNoteReturnNew,
              PATH_DASHBOARD.accounts.goodReceiptNoteReturnDetail,
              PATH_DASHBOARD.accounts.goodReceiptNoteReturnEdit,
            ],
          },
          {
            title: "AP Invoice Returns",
            path: PATH_DASHBOARD.accounts.apInvoiceReturn,
            pathList: [
              PATH_DASHBOARD.accounts.apInvoiceReturn,
              PATH_DASHBOARD.accounts.apInvoiceReturnNew,
              PATH_DASHBOARD.accounts.apInvoiceReturnDetail,
              PATH_DASHBOARD.accounts.apInvoiceReturnEdit,
            ],
          },
          {
            title: "Advance Payment Returns",
            path: PATH_DASHBOARD.accounts.advancePaymentReturn,
            pathList: [
              PATH_DASHBOARD.accounts.advancePaymentReturn,
              PATH_DASHBOARD.accounts.advancePaymentReturnNew,
              PATH_DASHBOARD.accounts.advancePaymentReturnDetail,
              PATH_DASHBOARD.accounts.advancePaymentReturnEdit,
            ],
          },
          {
            title: "Banking Returns",
            path: PATH_DASHBOARD.accounts.bankingReturn,
            pathList: [
              PATH_DASHBOARD.accounts.bankingReturn,
              PATH_DASHBOARD.accounts.bankingReturnNew,
              PATH_DASHBOARD.accounts.bankingReturnDetail,
              PATH_DASHBOARD.accounts.bankingReturnEdit,
            ],
          },
        ],
      },

      // Invoice
      {
        title: "Invoice",
        path: PATH_DASHBOARD.invoice.list,
        pathList: [
          PATH_DASHBOARD.invoice.list,
        ],
        icon: ICONS.Inventory,
      },
      // REPORTS
      {
        title: "report",
        path: PATH_DASHBOARD.general.report,
        pathList: [PATH_DASHBOARD.general.report],
        icon: ICONS.analytics,
      },
      {
        title: "settings",
        path: PATH_DASHBOARD.settings.new,
        pathList: [
          PATH_DASHBOARD.settings.new,
          PATH_DASHBOARD.settings.kds,
          PATH_DASHBOARD.settings.edit,
        ],
        icon: ICONS.lock,
      },
    ],
  },
];

export default navConfig;
